const BulletGap = () => {
  return (
    <span className="h-1 w-1 flex rounded-full bg-gray-500 mx-2 whitespace-nowrap overflow-ellipsis min-w-0"></span>
  );
}
 
export default BulletGap;